<template>
  <v-app>
    <global-header />
    <v-main>
      <transition name="fade">
        <router-view />
      </transition>
    </v-main>
    <global-footer />
  </v-app>
</template>

<script>
import GlobalFooter from "./components/GlobalFooter";
import GlobalHeader from "./components/GlobalHeader";

export default {
  name: "App",
  components: {
    GlobalFooter,
    GlobalHeader,
  },
};
</script>
<style lang="scss" scoped>
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
